import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "src/app/core/api.service";
import { LoggerService } from "src/app/core/logger.service";
import { UserService } from "src/app/core/user.service";
import { ErrCode, User } from "src/app/shared/models";
import { SnackbarService } from "src/app/shared/services/snackbar.service";

type Page = 'verify-email'

@Component({
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent implements OnInit {
  protected spinner: boolean = false;
  protected user: User;
  private confirmcode: string;
  protected errcode: ErrCode;
  protected verificationSpinner: boolean = false;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private api: ApiService,
    private router: Router,
    private log: LoggerService,
    private snackbar: SnackbarService,
  ) { }

  ngOnInit() {
    this.user = this.authenticated ? this.userService.getUser() : new User();
    this.confirmcode = this.route.snapshot.queryParams['c'];
    if (this.confirmcode) {
      this.verify();
    }
    else {
      this.errcode = new ErrCode(8103, 'No confirmation code provided');
    }
  }

  public async verify() {
    this.spinner = true;
    try {
      const result = await this.api.send('userverifyemail', {
        verify_code: this.confirmcode
      });
      if (this.authenticated && this.user.id === result['user_id']) {
        const dashboard = this.userService.get('dashboard') || 'files';
        this.router.navigate([`/${dashboard}`], { queryParams: undefined });
      }
      else {
        this.router.navigate(['/login'], { queryParams: { verified: 1 } });
      }
    }
    catch (ex) {
      this.log.error('Unable to verify email');
      this.log.error(ex);
      this.errcode = ErrCode.fromException(ex);
    }
    this.spinner = false;
  }

  protected resendVerification = async () => {
    this.verificationSpinner = true;
    try {
      await this.api.execute('userverifyemailresend', {});
      this.snackbar.showMessage('success', 'Verification email sent.');
    }
    catch (ex) {
      this.errcode = ErrCode.fromException(ex);
    }
    this.verificationSpinner = false;
  }

  protected get authenticated() {
    return this.userService.isAuthenticated();
  }
}
